module.exports = __webpack_public_path__ + "img/login_left.3a0546c8.png";